module.exports = __webpack_public_path__ + "e493fd0429c1730e639490795de14130.svg";